import { render } from "./GenesisContentBlocks.vue?vue&type=template&id=7b591750&scoped=true"
import script from "./GenesisContentBlocks.vue?vue&type=script&lang=js"
export * from "./GenesisContentBlocks.vue?vue&type=script&lang=js"

import "./GenesisContentBlocks.vue?vue&type=style&index=0&id=7b591750&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b591750"],['__file',"js/components/GenesisContentBlocks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b591750"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b591750', __exports__)) {
    api.reload('7b591750', __exports__)
  }
  
  module.hot.accept("./GenesisContentBlocks.vue?vue&type=template&id=7b591750&scoped=true", () => {
    api.rerender('7b591750', render)
  })

}


export default __exports__